const zwnj = String.fromCharCode(0x200C);

export function firstLetter(str: string) {
    if (str.length == 0) {
        return "";
    }

    const words = str.split(" ");
    if (words.length == 1) {
        return str[0];
    } else {
        return words[0][0];
    }
}
